import { analyticsService } from '../index-business';

export interface GradeEventData {
  studioClientId?: string;
  attendanceId?: string;
  ownerId?: string;
  grades?: any[];
  [key: string]: any;
}

export class GradeTracker {

  static trackAddGrades(data: {
    studioClientId: string;
    attendanceId: string;
    grades: any[];
    success: boolean;
    error?: string;
    duration?: number;
  }) {
    const eventData = {
      studio_client_id: data.studioClientId,
      attendance_id: data.attendanceId,
      grades_count: data.grades?.length || 0,
      grade_types: data.grades?.map(grade => grade.type || grade.gradeType).filter(Boolean) || [],
      grade_values: data.grades?.map(grade => grade.value || grade.grade).filter(val => val !== undefined) || [],
      average_grade: data.grades?.length > 0 ?
        data.grades.reduce((sum, grade) => sum + (Number(grade.value || grade.grade) || 0), 0) / data.grades.length : 0,
      max_grade: data.grades?.length > 0 ?
        Math.max(...data.grades.map(grade => Number(grade.value || grade.grade) || 0)) : 0,
      min_grade: data.grades?.length > 0 ?
        Math.min(...data.grades.map(grade => Number(grade.value || grade.grade) || 0)) : 0,
      success: data.success,
      error_message: data.error,
      api_duration_ms: data.duration,
      event_type: 'api_call',
      api_endpoint: 'addGrades',
      timestamp: new Date().toISOString()
    };

    analyticsService.track('Grades Added', eventData);
  }

  static trackUpdateGrades(data: {
    studioClientId: string;
    attendanceId: string;
    grades: any[];
    success: boolean;
    error?: string;
    duration?: number;
  }) {
    const eventData = {
      studio_client_id: data.studioClientId,
      attendance_id: data.attendanceId,
      grades_count: data.grades?.length || 0,
      grade_types: data.grades?.map(grade => grade.type || grade.gradeType).filter(Boolean) || [],
      grade_values: data.grades?.map(grade => grade.value || grade.grade).filter(val => val !== undefined) || [],
      average_grade: data.grades?.length > 0 ?
        data.grades.reduce((sum, grade) => sum + (Number(grade.value || grade.grade) || 0), 0) / data.grades.length : 0,
      max_grade: data.grades?.length > 0 ?
        Math.max(...data.grades.map(grade => Number(grade.value || grade.grade) || 0)) : 0,
      min_grade: data.grades?.length > 0 ?
        Math.min(...data.grades.map(grade => Number(grade.value || grade.grade) || 0)) : 0,
      success: data.success,
      error_message: data.error,
      api_duration_ms: data.duration,
      event_type: 'api_call',
      api_endpoint: 'updateGrades',
      timestamp: new Date().toISOString()
    };

    analyticsService.track('Grades Updated', eventData);
  }

  static trackAddGradeConfig(data: {
    ownerId: string;
    success: boolean;
    error?: string;
    duration?: number;
  }) {
    const eventData = {
      owner_id: data.ownerId,
      success: data.success,
      error_message: data.error,
      api_duration_ms: data.duration,
      event_type: 'api_call',
      api_endpoint: 'addGradeConfig',
      timestamp: new Date().toISOString()
    };

    analyticsService.track('Grade Config Created', eventData);
  }

  static trackGradeApiCall(endpoint: string, data: GradeEventData & {
    success: boolean;
    error?: string;
    duration?: number;
  }) {
    const eventData = {
      ...data,
      event_type: 'api_call',
      api_endpoint: endpoint,
      timestamp: new Date().toISOString()
    };

    analyticsService.track(`Grade API: ${endpoint}`, eventData);
  }
}

export const trackGradeSuccess = (endpoint: string, data: GradeEventData, duration?: number) => {
  GradeTracker.trackGradeApiCall(endpoint, {
    ...data,
    success: true,
    duration
  });
};

export const trackGradeError = (endpoint: string, error: string, data: GradeEventData, duration?: number) => {
  GradeTracker.trackGradeApiCall(endpoint, {
    ...data,
    success: false,
    error,
    duration
  });
};

export default GradeTracker;
